export default __webpack_public_path__ + "static/media/Flash of Sunup.7510ed72.png";